import createVueComponent from '../createVueComponent';

const ChevronRightCircle = createVueComponent('ChevronRightCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm10 8 4 4-4 4', key: '1wy4r4' }],
]);

export default ChevronRightCircle;
